import { useState } from 'react'

export const useCounter = (): [number, () => void] => {
  const [count, setCount] = useState(0)
  return [count, () => setCount(count + 1)]
}
